import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Snackbar } from '@mui/material';

import {
  closeSnackbar,
  selectMessage,
  selectOpen,
  selectSeverity,
} from './snackSlice';

function AktivuSnackbar() {
  const vertical = 'top';
  const horizontal = 'right';
  const open = useSelector(selectOpen);
  const severity = useSelector(selectSeverity);
  const message = useSelector(selectMessage);
  const dispatch = useDispatch();

  return (
    <Snackbar
      autoHideDuration={3000}
      open={open}
      anchorOrigin={{ vertical, horizontal }}
      onClose={() => {
        dispatch(closeSnackbar());
      }}
    >
      <Alert severity={severity} elevation={6} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
}

export default AktivuSnackbar;
